export default "<p>\r\n  asignacion-transportador-agencia works!\r\n</p>\r\n"